import { createContext, useEffect, useState, useContext } from 'react';
import { API } from '../lib/axios';

export const CollectionsContext = createContext();

export const CollectionsProvider = ({ children }) => {
    const [collections, setCollections] = useState([]);
    const [loading, setLoading] = useState(true)


    const fetchCollections = async () => {
        try {
            setLoading(true);
            const res = await API.get("/collections");
            setCollections(res.data);
        } catch (error) {
            // Silent fail - collections will be empty
        } finally {
            setLoading(false);
        }
    };


    // Defer collections loading to improve initial page render
    // Collections are not critical for product pages
    useEffect(() => {
        const timer = setTimeout(() => {
            fetchCollections();
        }, 200); // Defer by 200ms to allow critical content to load first

        return () => clearTimeout(timer);
    }, []);


    return (
        <CollectionsContext.Provider value={{ collections, setCollections, loading,setLoading,fetchCollections }}>
            {children}
        </CollectionsContext.Provider>
    );
};

// Optional: Custom hook
export const useCollections = () => useContext(CollectionsContext);
